import { createContext, useContext } from "react";

/**
 * Disponibilizado pelo `Modal` aos formulários dentro dele: pedir o fechamento passando pela
 * proteção (aviso "Sair sem salvar?" e bloqueio durante o salvamento).
 */
export const ModalContexto = createContext<{ solicitarFechamento: () => void } | null>(null);

export function useModalContexto() {
  return useContext(ModalContexto);
}
